import dynamic from 'next/dynamic';
import Head from 'next/head';
import Script from 'next/script';
import { useEffect } from 'react';

const HeroBanner = dynamic(() => import('../HeroBanner'));
const ArticleContent = dynamic(() => import('../ArticleContent'));
const ArticleBlock = dynamic(() => import('../ArticleBlock'));

const Post = (props) => {
  const page = require('../../theme/pages.module.scss');
  const { article } = props.data;

  let meta_info = [];
  let meta_info_og = [];
  const regex = /(<([^>]+)>)/gi;
  const sanitisedContent = article[0].article.content.replace(regex, '');
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': 'https://google.com/article',
    },
    headline: article[0].hero_section.title,
    image: [article[0].hero_section.image.large],
    url: article[0].social.article_link,
    datePublished: article[0].hero_section.date,
    dateModified: article[0].hero_section.date,
    author: {
      '@type': 'Person',
      name: article[0].social.fullname,
    },
    publisher: {
      '@type': 'Organization',
      name: 'Vodacom',
      logo: {
        '@type': 'ImageObject',
        url: 'https://www.vodacom.co.za/themes/custom/blip/img/menu/vodacom-logo.png',
      },
    },
    description: article[0].hero_section.blurb,
    articleBody: sanitisedContent,
  };
  const TWQ = `!function(e,t,n,s,u,a){e.twq||(s=e.twq=function(){s.exe?s.exe.apply(s,arguments):s.queue.push(arguments);
                },s.version='1.1',s.queue=[],u=t.createElement(n),u.async=!0,u.src='//static.ads-twitter.com/uwt.js',
                a=t.getElementsByTagName(n)[0],a.parentNode.insertBefore(u,a))}(window,document,'script');
                // Insert Twitter Pixel ID and Standard Event data below
                twq('init','nujyj');
                twq('track','PageView');`;

  /*
   * meta info for the page
   */
  if (
    props.data.meta &&
    props.data.meta.meta_title &&
    props.data.meta.meta_title === ''
  ) {
    article.map(
      (i) =>
        (meta_info = [
          { name: 'title', content: i.hero_section.title },
          { name: 'description', content: i.hero_section.blurb },
          { name: 'keywords', content: i.hero_section.blurb },
        ])
    );
  } else {
    meta_info = [
      {
        name: 'title',
        content:
          props.data.meta && props.data.meta.meta_title
            ? props.data.meta.meta_title
            : '',
      },
      {
        name: 'description',
        content:
          props.data.meta && props.data.meta.meta_description
            ? props.data.meta.meta_description
            : '',
      },
      {
        name: 'keywords',
        content:
          props.data.meta && props.data.meta.meta_keywords
            ? props.data.meta.meta_keywords
            : '',
      },
    ];
  }

  /*
   *if og tags push into meta array ^^
   */
  if (
    props.data.meta &&
    props.data.meta.og &&
    props.data.meta.og.title === ''
  ) {
    article.map((i) =>
      meta_info_og.push(
        { property: `og:title`, content: i.hero_section.title },
        { property: `og:description`, content: i.hero_section.blurb },
        { property: `og:image`, content: i.hero_section.image.large },
        {
          property: `og:type`,
          content: i.hero_section.date
            ? `article:${new Date(i.hero_section.date).toISOString()}`
            : 'article',
        },
        { property: `og:url`, content: i.social.article_link },
        { property: 'twitter:title', content: i.hero_section.title },
        { property: 'twitter:description', content: i.hero_section.blurb },
        { property: 'twitter:image', content: i.hero_section.image.large },
        { name: 'twitter:card', content: 'summary_large_image' }
      )
    );
  } else {
    meta_info_og.push(
      {
        property: `og:title`,
        content:
          props.data.meta && props.data.meta.og ? props.data.meta.og.title : '',
      },
      {
        property: `og:description`,
        content:
          props.data.meta && props.data.meta.og
            ? props.data.meta.og.description
            : '',
      },
      {
        property: `og:image`,
        content:
          props.data.meta && props.data.meta.og ? props.data.meta.og.image : '',
      },
      {
        property: `og:type`,
        content: i.hero_section.date
          ? `article:${new Date(i.hero_section.date).toISOString()}`
          : 'article',
      },
      {
        property: `og:url`,
        content:
          props.data.meta && props.data.meta.og ? props.data.meta.og.title : '',
      },
      {
        property: 'twitter:title',
        content:
          props.data.meta && props.data.meta.og ? props.data.meta.og.title : '',
      },
      {
        property: 'twitter:description',
        content:
          props.data.meta && props.data.meta.og
            ? props.data.meta.og.description
            : '',
      },
      {
        property: 'twitter:image',
        content:
          props.data.meta && props.data.meta.og ? props.data.meta.og.image : '',
      },
      { name: 'twitter:card', content: 'summary_large_image' }
    );
  }

  useEffect(() => {
    utag.view();
  }, []);

  return (
    <div className={page.Wrapper}>
      <Head>
        <title>
          {props.data.meta && props.data.meta.meta_title === ''
            ? 'Vodacom Blog'
            : props.data.meta.meta_title}
        </title>
        <meta name='viewport' content='initial-scale=1.0, width=device-width' />
        <meta
          name='google-site-verification'
          content='8iRkog4syZoPU8w-pOrnIZZ5wdRikoJwjbeuxdWoI64'
        />
        <link rel="sitemap" type="application/xml" title="Sitemap" href="/sitemap.xml"></link>
        <meta name='theme-color' content='#ffffff' />
        <meta name='color-scheme' content='light' />
        <Script defer dangerouslySetInnerHTML={{ __html: TWQ }} />
      </Head>
      <Head>
        <Script
          type='application/ld+json'
          dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
        />
      </Head>
      {meta_info &&
        meta_info.map((i, index) => (
          <Head key={index}>
            <meta name={i.name} content={i.content} />
          </Head>
        ))}
      {meta_info_og &&
        meta_info_og.map((i, index) => (
          <Head key={index}>
            {i.name ? (
              <meta name={i.name} content={i.content} />
            ) : (
              <meta property={i.property} content={i.content} />
            )}
          </Head>
        ))}
      {article.length > 0 &&
        article.map((item, index) => {
          return (
            <div key={index}>
              <HeroBanner {...item.hero_section} />
              <div
                className={
                  item.article.postTakeover
                    ? page.TakeoverContent
                    : page.PostContent
                }>
                <ArticleContent {...item.article} />
                <ArticleBlock
                  {...item.social}
                  postTakeover={item.article.post_takeover}
                />
              </div>
            </div>
          );
        })}
    </div>
  );
};

export default Post;
